module.exports = __webpack_public_path__ + "static/media/store_week_en.387f037a.svg";